module.exports = __webpack_public_path__ + "static/media/sub7.e06cf77a.png";